import URLS from '../../constants/urls';
import api from '../config';
export const _uploadLocationImage = async (siteId, locationId, type, data) => {
    const response = await api.post(`${URLS.IMAGE}/location/${siteId}/${locationId}?imageType=${type}`, data);
    return response.data;
};
export const _uploadMapObject = async (siteId, locationId, scale, formData) => {
    console.log(formData, "form data");
    const response = await api.post(`${URLS.MAP_OBJECT}/${siteId}/${locationId}?scale=${scale}`, formData);
    return response.data;
};
export const _uploadCategoryImage = async (siteId, categoryId, data) => {
    const response = await api.post(`${URLS.IMAGE}/category/${siteId}/${categoryId}`, data);
    return response.data;
};
export const _uploadEventImage = async (siteId, eventId, data) => {
    try {
        const response = await api.post(`${URLS.IMAGE}/event/${siteId}/${eventId}`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
};
export const _deleteEventImage = async (siteId, eventId, data) => {
    try {
        const response = await api.delete(`${URLS.IMAGE}/event/${siteId}/${eventId}`, { data });
        return response.data;
    }
    catch (error) {
        return error;
    }
};
